import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toastify } from "../../../helperFunctions/toastify";
import DateInput from "../../SharedComponents/DateInput";
import { setTableSearch } from "../../../redux/slices/commonSlice";
import { getLowStockReport } from "../../../apis/customTemplate";

import {
    downloadCsv,
    formatDate,
} from "../../../helperFunctions/utils";
const FilterWrapper = styled.div`
  label {
    color: inherit;
  }

  .btn-wrapper {
    align-items: center;
    display: flex;
    margin-top: 20px;
  }
`;

function LowStockReport() {
    const dispatch = useDispatch();
    const location = useLocation();
    const buttonRef = useRef(null);
    const pathname = location.pathname;
    const fieldPathname = pathname.replace("/", "");

    const { tableSearch } = useSelector((state) => state.commonData);

    const [filteredData, setFilteredData] = useState([]);
    const [refundList, setRefundList] = useState([]);

    const onReduxFilter = () => {
        dispatch(
            setTableSearch({
                ...tableSearch,
                [fieldPathname]: {
                    ...tableSearch[fieldPathname],
                    lowStock: {},
                },
            })
        );
    };

    // useEffect(() => {
    //   (async () => {
    //     const response = await getPatients();
    //     if (response?.status !== "Fail") {
    //       setPatients(response);
    //     } else {
    //       toastify("Failed to get patients", "error");
    //     }
    //   })();
    // }, []);

    useEffect(() => {
        if (
            buttonRef.current
        ) {
            setTimeout(() => {
                if (buttonRef.current) {
                    buttonRef.current.click();
                }
            }, [1000]);
        }
    }, []);

    useEffect(() => {
        getLowStockReport({}).then((res) => {
            console.log("res?.result?.data", res?.result?.data);
            if (res?.result?.data) {
                setRefundList(res.result.data);
                setFilteredData(res.result.data);
            }
        });
    }, []);

    const onSearch = () => {

    }


    // eslint-disable-next-line no-sparse-arrays
    const columns = [
        {
            name: "Code",
            selector: (row) => row.code,
            cell: (row) => row.code,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            cell: (row) => row.name,
        },
        {
            name: "Batch Number",
            selector: (row) => row.batchNumber,
            cell: (row) => row.batchNumber,
        },
        {
            name: "Quantity",
            selector: (row) => row.qty,
            cell: (row) => row.qty,
        },
        {
            name: "Exipred Date",
            selector: (row) => row.expDate,
            cell: (row) => formatDate(row.expDate),
        },
    ];

    const data = filteredData?.map((e, index) => {
        return {
            ...e,
            index,
            key: index,
        };
    });

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
            },
        },
    };

    const conditionalRowStyles = [
        {
            when: (row) => row,
            style: {
                borderWidth: "0px",
            },
        },
        {
            when: (row) => row.index % 2 === 1,
            style: {
                backgroundColor: "#f8f8f8",
                borderWidth: "0px",
            },
        },
    ];

    const exportCsv = () => {
        const csvData = refundList.map((row) => ({
            "Code": row.code,
            "Name": row.name,
            "Batch Number": row.batchNumber,
            "Quantity": row.qty,
            "Exipred Date": formatDate(row.expDate),
        }));

        downloadCsv(csvData, "Low_Stock_Report");
    };

    return (
        <div className="p-0">
            <div
                className="mainHeading"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <FilterWrapper className="d-flex">
                        <div className="btn-wrapper">
                            {/* <Button
                                ref={buttonRef}
                                className="addItem me-3"
                                onClick={() => {
                                    onSearch();
                                }}
                            >
                                Search
                            </Button> */}
                            <Button className="addItem" onClick={() => exportCsv()}>
                                Export
                            </Button>
                        </div>
                    </FilterWrapper>
                </div>
            </div>

            <DataTable
                columns={columns}
                data={data || []}
                pagination
                customStyles={customStyles}
                conditionalRowStyles={conditionalRowStyles}
            />
        </div>
    );
}

export default LowStockReport;
